import React from 'react';
import styles from './StatusBannerPanel.module.css';

const formatCount = (n) => (Number(n) === 0 ? '0' : String(n).padStart(2, '0'));

const DEFAULT_STATUS_CONFIG = [
  { key: 'pendente', label: 'Pendente' },
  { key: 'aceito', label: 'Aceito' },
  { key: 'andamento', label: 'Em Andamento' },
  { key: 'finalizado', label: 'Finalizado' },
  { key: 'cancelado', label: 'Cancelado' },
];

export default function StatusBannerPanel({ counts = {}, activeFilter = [], onSelectFilter, statusConfig, title = 'Status da Programação', variant }) {
  const config = statusConfig || DEFAULT_STATUS_CONFIG;
  const isNeutral = variant === 'neutral';

  return (
    <div className={styles.container}>
      <div className={`${styles.header} ${isNeutral ? styles.headerNeutral : ''}`}>{title}</div>
      <div className={styles.grid}>
        {config.map((status) => {
          const isSelected = activeFilter.includes(status.key);
          const raw = counts[status.key] || 0;
          const isObject = typeof raw === 'object';
          const count = isObject ? raw.count : raw;
          const hasVolume = isObject && raw.volume != null && Number(count) > 0;

          return (
            <button
              key={status.key}
              className={`${styles.card} ${isNeutral ? styles.cardNeutral : ''} ${isSelected ? styles.active : ''}`}
              onClick={() => onSelectFilter(status.key)}
            >
              <span className={styles.label}>{status.label}</span>
              <span className={styles.statsRow}>
                <span className={styles.volume}>
                  {hasVolume ? `${Number(raw.volume).toLocaleString()} TON` : ''}
                </span>
                <span className={styles.count}>
                  {formatCount(count)}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
